/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import entityTableTemplate from '../table/entity-table.tpl.html';
import providerDetailsTemplate from './provider-details.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function ProviderRoutes($stateProvider, $injector) {

    var types = $injector.get('types');

    $stateProvider
        .state('home.providers', {
            url: '/providers',
            module: 'private',
            auth: [types.authority.SYS_ADMIN.value, types.authority.SYS_USER.value],
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'provider.providers'
            },
            ncyBreadcrumb: {
                label: '{"svgIcon": "tk:providers", "label": "provider.providers"}'
            },
            resolve: {
                entityTableConfiguration:
                /*@ngInject*/
                    function($stateParams, providerTableConfig) {
                        return providerTableConfig.getConfig($stateParams);
                    }
            }
        })
        .state('home.provider', {
            url: '/provider',
            module: 'private',
            auth: [types.authority.PROVIDER_ADMIN.value, types.authority.PROVIDER_USER.value],
            views: {
                "content@home": {
                    templateUrl: providerDetailsTemplate,
                    controllerAs: 'vm',
                    controller: 'ProviderDetailsController'
                }
            },
            data: {
                pageTitle: 'provider.provider'
            },
            ncyBreadcrumb: {
                label: '{"svgIcon": "tk:providers", "label": "provider.provider"}'
            }
        });

}



// WEBPACK FOOTER //
// ./src/app/provider/provider.routes.js